import React, {useEffect, useState} from "react";
import {InboxOutlined} from "@ant-design/icons";
import {Checkbox, Form, Input, message, Modal, Spin, Upload} from "antd";
import api from "../../api";
import { Auth } from "@digatex/digatex-ui-lib";

const {Dragger} = Upload;

export function UploadCustomRecommendationsModal({isModalVisible, setIsModalVisible, projectId, scopeId}) {
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState([]);
    const [loading, setLoading] = useState(false);
    const lockChecked = Form.useWatch("lock", form);

    useEffect(() => {
        if (!isModalVisible) {
            return;
        }
        const tokenParsed = Auth.tokenParsed();
        const userName = tokenParsed?.name || tokenParsed?.preferred_username || "User";
        const dateStr = new Date().toISOString().split("T")[0];
        form.setFieldsValue({
            name: `${userName} ${dateStr} Override`,
            lock: false,
        });
    }, [isModalVisible, form]);

    const handleCancel = () => {
        form.resetFields();
        setFileList([]);
        setIsModalVisible(false);
    };

    const handleOk = () => {
        form.validateFields()
            .then(values => {
                if (!fileList.length) {
                    message.error("Please upload a file first!");
                    return;
                }

                setLoading(true);
                const formData = new FormData();
                formData.append("name", values.name);
                formData.append("lock", values.lock ? "true" : "false");
                formData.append("scope_id", scopeId);
                formData.append("file", fileList[0]);

                api.post(`/projects/${projectId}/custom-recommendations/upload`, formData)
                    .then((res) => {
                        message.success(res.data.message || "Custom recommendations uploaded successfully");
                        handleCancel();
                    })
                    .catch(() => {})
                    .finally(() => {
                        setLoading(false);
                    });
            })
            .catch(() => {});
    };

    const uploadProps = {
        onRemove: () => setFileList([]),
        beforeUpload: file => {
            const isExcel = file.name.endsWith(".xlsx");
            if (!isExcel) {
                message.error("Only Excel files are supported!");
                return Upload.LIST_IGNORE;
            }
            setFileList([file]);
            return false;
        },
        fileList,
        maxCount: 1,
        accept: ".xlsx"
    };

    return (
        <Modal
            title="Upload Custom Recommendations"
            open={isModalVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            confirmLoading={loading}
            destroyOnClose>
            <Spin spinning={loading}>
                <Form form={form} layout="vertical" preserve={false}>
                    <Form.Item name="name" label="Recommendation Name" rules={[{required: true}]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="lock" valuePropName="checked">
                        <Checkbox>Lock new recommendations</Checkbox>
                    </Form.Item>
                    {lockChecked && (
                        <p style={{color: "red", fontSize: "12px", marginTop: "-10px"}}>
                            Warning: Checking the lock box will unlock previous recommendations and lock the new ones.
                        </p>
                    )}
                    <p style={{fontSize: "12px"}}>
                        Your file must contain the following columns: <b>recommendation, min, max, material</b>.
                    </p>
                    <Form.Item label="Excel File">
                        <Dragger {...uploadProps}>
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">Click or drag file to this area to upload</p>
                        </Dragger>
                    </Form.Item>
                </Form>
            </Spin>
        </Modal>
    );
}
